import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'DATEBUCKET',
  category: FunctionCategory.TIMESTAMP,
  description: 'Truncate date to closest multiple of time partition',
  shortDescription: 'Truncate date to specified precision',
  params: [
    {
      name: 'part string',
      type: ArgType.text,
      description: 'The nearest multiple of a part to truncate to (example: "5 minutes").',
    },
    {
      name: 'date string',
      type: ArgType.text,
      description: 'The date to extract part from (example: "01/01/2024 12:02pm").',
    },
  ],
} satisfies AnalysisFunction;
